
import type { UseCanvasModalsReturn } from '@/components/workspace/hooks'
import {
  CanvasRenameModal,
  CanvasMoveModal,
  CanvasDeleteModal,
  CanvasDuplicateModal,
} from '@/components/workspace/modals'

interface CanvasActionModalsProps {
  modalProps: UseCanvasModalsReturn['modalProps']
  modalHandlers: UseCanvasModalsReturn['modalHandlers']
  onClose: () => void
}

/**
 * The rename / move / delete / duplicate dialogs every session list puts behind its grid.
 * Trash has its own pair (restore and delete forever) and does not use this.
 */
export function CanvasActionModals({ modalProps, modalHandlers, onClose }: CanvasActionModalsProps) {
  return (
    <>
      <CanvasRenameModal
        isOpen={modalProps.isRenameOpen}
        onClose={onClose}
        canvas={modalProps.canvas}
        onRename={modalHandlers.onRename}
      />

      <CanvasMoveModal
        isOpen={modalProps.isMoveOpen}
        onClose={onClose}
        canvas={modalProps.canvas}
        projects={modalProps.projects}
        onMove={modalHandlers.onMove}
      />

      <CanvasDeleteModal
        isOpen={modalProps.isDeleteOpen}
        onClose={onClose}
        canvas={modalProps.canvas}
        onDelete={modalHandlers.onDelete}
      />

      <CanvasDuplicateModal
        isOpen={modalProps.isDuplicateOpen}
        onClose={onClose}
        canvas={modalProps.canvas}
        onDuplicate={modalHandlers.onDuplicate}
      />
    </>
  )
}
